import config from "@/config/config";
import { headers } from "./auth.headers";
import { formatQueryString } from "@/helpers/query-string";
import { LoginHistory } from "@/domain/login-history.model";
import { IPaginateVueTable } from "@/interfaces/IPaginateVueTable";
import httpClient from "@/helpers/http-client";

export default class LoginHistoryService {
  private static urlApiBase = config.url_api_base;

  static get = (id: string): Promise<LoginHistory> => {
    const url = `${this.urlApiBase}/login-history/${id}`;

    return httpClient
      .request<LoginHistory>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static list = (
    offset?: number,
    limit?: number,
    order?: string,
    sort?: string,
    filter?: Record<string, unknown>,
  ): Promise<IPaginateVueTable<LoginHistory>> => {
    const query = formatQueryString(offset, limit, order, sort, filter, true);
    const url = `${this.urlApiBase}/login-history${query}`;

    return httpClient
      .request<IPaginateVueTable<LoginHistory>>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static export = (filter?: Record<string, unknown>): Promise<LoginHistory[]> => {
    const query = formatQueryString(undefined, undefined, undefined, undefined, filter, true);
    const url = `${this.urlApiBase}/login-history/export${query}`;

    return httpClient
      .request<LoginHistory[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static listActive = (): Promise<LoginHistory[]> => {
    const url = `${this.urlApiBase}/terms-use/list-active`;

    return httpClient
      .request<LoginHistory[]>({
        url,
        method: "GET",
        headers: headers(),
      })
      .then(result => result?.body);
  };

  static delete = (id: string): Promise<LoginHistory> => {
    const url = `${this.urlApiBase}/terms-use/${id}`;

    return httpClient
      .request<LoginHistory>({
        url,
        method: "DELETE",
        headers: headers(),
      })
      .then(result => result?.body);
  };
}
